import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/favorites/interests.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var paths = {
  artists: "/artists",
  cuisines: "/cuisines",
  teams: "/teams/list",
  tv_shows: "/tv-shows",
  sports: "/sports"
};
var getInterestOptions = (_0) => __async(void 0, [_0], function* ({ type, lang, page = 1 }) {
  try {
    const locale = getLocaleOnly(lang);
    const res = yield fetchClient({
      url: `${paths[type]}?lang=${locale}&page=${page}`
    });
    return res.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getInterestOptionsException"
    });
  }
});

export {
  getInterestOptions
};
//# sourceMappingURL=chunk-MAFZ4IXM.mjs.map